"use client";

import { Modal } from "flowbite-react";

interface Props {
  title: string,
  openModal: boolean,
  onClose: VoidFunction,
  children: React.ReactNode;
}

const LinkInputModal: React.FC<Props> = ({ title, openModal, onClose, children }) => {

  return (
    <>
      <Modal show={openModal} size="md" onClose={onClose} popup>
        {title && <Modal.Header style={{paddingLeft: "1.5em"}}>{title}</Modal.Header>}
        <Modal.Body>
          {children}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default LinkInputModal;
